export function toLowerCase(text: string) {
  return text.toLowerCase();
}

export function textLimit(text = "", length: number) {
  if (!text) {
    return "";
  }
  return text.length > length ? text.substring(0, length) + "..." : text;
}

export function formatBytes(_a: number | string, b?: number) {
  if (0 === _a) return "0 Bytes";
  const a = Number(_a);
  const c = 1024,
    d = b || 2,
    e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}

export const capitalize = (a: string) => {
  const b = a.toLowerCase();
  const split = b.split("_");

  if (split.length > 0) {
    const res: string[] = split.map((v: string) => {
      return v.charAt(0).toUpperCase() + v.slice(1);
    });

    const result: string = res.join(" ");
    return result
      .split(" ")
      .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
      .join(" ");
  }

  return b.charAt(0).toUpperCase() + b.slice(1);
};

export function convertToRupiah(angka: number | string) {
  if (!angka) {
    return "Rp 0";
  }
  let rupiah = "";
  const angkarev = angka.toString().split("").reverse().join("");
  for (let i = 0; i < angkarev.length; i++) if (i % 3 === 0) rupiah += angkarev.substr(i, 3) + ",";
  return (
    "Rp " +
    rupiah
      .split("", rupiah.length - 1)
      .reverse()
      .join("") +
    ".00"
  );
}

export const slugValidate = (text: string) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // eslint-disable-line
    .replace(/\-\-+/g, "-"); // eslint-disable-line
};

export const normalizeRupiah = (v: string) => {
  if (!v) return "";
  const cleanedInput = v.replace(/[^\d]/g, "");
  if (cleanedInput) {
    const _cleanedInput = Number(cleanedInput);
    const convertedInput = new Intl.NumberFormat().format(_cleanedInput);
    return `Rp ${convertedInput}`;
  } else return "";
};

export const normalizeOnlyNumber = (v: string) => {
  if (!v) return "";
  const cleanedInput = v.replace(/[^\d]/g, "");
  return cleanedInput ? cleanedInput : "";
};

export const create_UUID = (short: boolean) => {
  let dt = new Date().getTime();
  let uuid = "";
  if (short) {
    uuid = "xxxxxxxx-4xxx".replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  } else {
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  return "UIID-" + uuid;
};

export const spaceToUnderscore = (text: string) => {
  return text.toLowerCase().replace(/\s+/g, "_");
};

export const toTitleCase = (str: string) => {
  if (str) {
    return str?.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
};

export const emptyString = (text?: string, params?: any) => {
  if (text?.toString() === "Invalid date") {
    return "-";
  }
  if (text) return params?.value || text;
  return params?.else || "-";
};

export const generateInitial = (name: string) => {
  if(name.length){
    const initial = name.split(' ').map(name => name[0]?.toUpperCase()).join('');
    return initial;
  }
  return '-';
};